export enum AccountType {
    Customer = 'customer',
    Supplier = 'supplier',
}
